// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

// ** Contacts
export const getContactsList = createAsyncThunk('appContacts/getContactsList', async params => {   
    params.page = params.page === 0 ? 0 : params.page - 1
    const response = await axios.post(`https://api.mfauto.com.ua/repair/contacts/list?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...params,
        token: localStorage.getItem('token')
    })

    return {
        params,
        data: response.data.contacts,
        totalPages: response.data.total_elements
    }
})

export const addContact = createAsyncThunk('appContacts/addContact', async (data) => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/contacts/add?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...data,
        token: localStorage.getItem('token')
    })
    return response.data
})

export const updateContact = createAsyncThunk('appContacts/updateContact', async (data) => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/contacts/edit?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...data,
        token: localStorage.getItem('token')
    })
    return response.data
})
export const getContact = createAsyncThunk('appContacts/getContact', async (id) => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/contacts/get?env=${process.env.REACT_APP_NODE_ENV}`, {
        id,
        token: localStorage.getItem('token')
    })
    return response.data
})
export const removeContact = createAsyncThunk('appContacts/removeContact', async (id) => {
    const response = await axios.post(`https://api.mfauto.com.ua/repair/contacts/remove?env=${process.env.REACT_APP_NODE_ENV}`, {
        id,
        token: localStorage.getItem('token')
    })
    return response.data
})

export const appContactsSlice = createSlice({
    name: 'appContacts',
    initialState: {        
        data: [],
        total: 1,
        params: {},
        settings: [],
        selectedContact: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
        .addCase(getContactsList.fulfilled, (state, action) => {
            state.data = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
        })
    }
})

export default appContactsSlice.reducer
